export const LINKEDIN_PAGE = "https://linkedin.com/company/onegradai/";
export const TERMS_AND_CONDITIONS_URL = "/terms";
export const PARTNER_TERMS_URL = "/partner-terms";
